// Ajustes > Meus dados (0.67, texto 05 D3, LGPD): baixar todos os meus dados e excluir a conta.
// Reaproveita o que já existia: o "Exportar arquivo" (cópia completa dos dados) e o "Apagar minha conta" de Segurança,
// que agora também pede a senha (useApagarConta, usado nas duas páginas).
import { useState } from 'react';
import { Alert, Platform, Text, View } from 'react-native';
import { useAuth } from '../../auth/AuthContext';
import { traduzErro } from '../../lib/supabase';
import { Btn, Field, Sheet } from '../../components/ui';
import { C } from '../../components/theme';
import { t } from '../../lib/i18n';
import { exportarArquivo } from './NuvemCopias';
import { exportarLegivel } from '../../lib/dadosLegiveis';
import { BotaoAcao, Bloco, Dica, LinhaEscolha } from '../../components/ajustes/Linhas';

/** Apagar a conta: confirmação e depois a senha da conta. */
export function useApagarConta() {
  const a = useAuth();
  const [aberto, setAberto] = useState(false);
  const [senha, setSenha] = useState('');
  const [indo, setIndo] = useState(false);
  const fechar = () => { setAberto(false); setSenha(''); };
  const pedir = () => Alert.alert(t('Apagar a conta?'), t('Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Não há como desfazer.'), [
    { text: t('Cancelar'), style: 'cancel' },
    { text: t('Continuar'), style: 'destructive', onPress: () => setAberto(true) }]);
  const apagar = async () => {
    if (indo) return;
    setIndo(true);
    try {
      if (!(await a.conferirSenha(senha))) { Alert.alert(t('Senha incorreta.'), t('Confira a senha da sua conta e tente de novo.')); return; }
      fechar();
      await a.deleteAccount();
    } catch (err) { Alert.alert(t('Não foi possível'), traduzErro(err)); }
    finally { setIndo(false); }
  };
  const tela = (
    <Sheet visible={aberto} onClose={fechar} title={t('Apagar minha conta')}>
      <View style={{ padding: 16, gap: 12 }}>
        <Text style={{ color: C.text, fontWeight: '800', fontSize: 16 }}>⚠️ {t('Tem certeza?')}</Text>
        <Text style={{ color: C.sub }}>{t('Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Não há como desfazer.')} {t('Digite a senha da sua conta para confirmar.')}</Text>
        <Field value={senha} onChangeText={setSenha} placeholder={t('Sua senha')} secureTextEntry autoCapitalize="none" autoCorrect={false} />
        <Btn cor={C.danger} disabled={!senha || indo} label={indo ? t('Conferindo...') : t('Apagar tudo')} onPress={apagar} />
      </View>
    </Sheet>
  );
  return { pedir, tela };
}

export default function MeusDados({ cor, onPrivacidade }: { cor: string; onPrivacidade: () => void }) {
  const conta = useApagarConta();
  return (<>
    {/* 0.72 (texto 10 C8): dois arquivos, cada um dizendo para que serve */}
    <Bloco titulo={t('Baixar meus dados')}>
      <Dica>{t('São dois arquivos com os seus dados do My Planner (portabilidade, LGPD):')}</Dica>
      <Dica>{'1. ' + t('Para ler (PDF): organizado por aba, com títulos e datas. Abre em qualquer dispositivo ou computador.')}</Dica>
      <BotaoAcao cor={cor} label={'📄 ' + t('Baixar para ler (PDF)')} onPress={() => { exportarLegivel().catch(e => Alert.alert(t('Não foi possível'), traduzErro(e))); }} />
      <Dica>{'2. ' + t('Técnico (para restaurar): cópia completa que só o My Planner lê. Para usar, vá em Ajustes › Nuvem e cópias de segurança › Importar arquivo.')}</Dica>
      {Platform.OS !== 'web'
        ? <BotaoAcao cor={cor} label={'🧩 ' + t('Baixar o arquivo técnico')} onPress={exportarArquivo} />
        : <Dica>{t('Use o app no celular para baixar o arquivo técnico.')}</Dica>}
    </Bloco>
    <Bloco titulo={t('Excluir minha conta')}>
      <Dica>{t('Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Pede a sua senha antes.')}</Dica>
      <BotaoAcao cor={C.danger} label={t('Apagar minha conta e todos os dados')} onPress={conta.pedir} />
    </Bloco>
    <Bloco>
      <LinhaEscolha icone="📄" titulo={t('Privacidade e termos')} onPress={onPrivacidade} />
    </Bloco>
    {conta.tela}
  </>);
}
